<div>
  @if (avatar) {
    <div class="imageCont">
      <img src="{{ avatar }}" />
    </div>
  } @else {
    <span class="initials">
      {{ initials }}
    </span>
  }

</div>
